// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 524 ? "app" : chunkId) + "." + {"524":"cd6536e20b2687d9b6ff","838":"cf9bc4177f51410cbc68"}[chunkId] + ".css";
};